// extracted by mini-css-extract-plugin
export default {"cls1":"UploadButton-cls1___b9541eb7771b7a12ced","cls2":"UploadButton-cls2___df7336c03b93ac34326 UploadButton-cls1___b9541eb7771b7a12ced"};